module.exports = __webpack_public_path__ + "static/media/logo.a9e76811.png";